import React, { createContext } from 'react';
export var AccordionContext = createContext({
    headingLevel: 2,
});
export var AccordionProvider = function (_a) {
    var children = _a.children, headingLevel = _a.headingLevel;
    return (React.createElement(AccordionContext.Provider, { value: { headingLevel: headingLevel } }, children));
};
